// source: buildFoundry.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.Category', null, global);
goog.exportSymbol('proto.DataSource', null, global);
goog.exportSymbol('proto.DateRange', null, global);
goog.exportSymbol('proto.Dimensions', null, global);
goog.exportSymbol('proto.FoundryItem', null, global);
goog.exportSymbol('proto.GetCategoriesRequest', null, global);
goog.exportSymbol('proto.GetCategoriesResponse', null, global);
goog.exportSymbol('proto.GetFoundryItemByIdRequest', null, global);
goog.exportSymbol('proto.GetFoundryItemByIdResponse', null, global);
goog.exportSymbol('proto.GetFoundryItemsByCategoryPathRequest', null, global);
goog.exportSymbol('proto.GetFoundryItemsByCategoryPathResponse', null, global);
goog.exportSymbol('proto.GetFoundryItemsRequest', null, global);
goog.exportSymbol('proto.GetFoundryItemsResponse', null, global);
goog.exportSymbol('proto.MarketIndicators', null, global);
goog.exportSymbol('proto.Meta', null, global);
goog.exportSymbol('proto.PriceHistoryEntry', null, global);
goog.exportSymbol('proto.PriceHistorySummary', null, global);
goog.exportSymbol('proto.PriceStatistics', null, global);
goog.exportSymbol('proto.QualityMetrics', null, global);
goog.exportSymbol('proto.QuantityRange', null, global);
goog.exportSymbol('proto.Supplier', null, global);
goog.exportSymbol('proto.SupplierSummary', null, global);
goog.exportSymbol('proto.Unit', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Category = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Category.repeatedFields_, null);
};
goog.inherits(proto.Category, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Category.displayName = 'proto.Category';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GetCategoriesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.GetCategoriesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GetCategoriesRequest.displayName = 'proto.GetCategoriesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GetCategoriesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.GetCategoriesResponse.repeatedFields_, null);
};
goog.inherits(proto.GetCategoriesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GetCategoriesResponse.displayName = 'proto.GetCategoriesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Dimensions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Dimensions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Dimensions.displayName = 'proto.Dimensions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Unit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Unit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Unit.displayName = 'proto.Unit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.FoundryItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.FoundryItem.repeatedFields_, null);
};
goog.inherits(proto.FoundryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.FoundryItem.displayName = 'proto.FoundryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PriceHistoryEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PriceHistoryEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PriceHistoryEntry.displayName = 'proto.PriceHistoryEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Supplier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Supplier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Supplier.displayName = 'proto.Supplier';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.QuantityRange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.QuantityRange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.QuantityRange.displayName = 'proto.QuantityRange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MarketIndicators = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MarketIndicators, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MarketIndicators.displayName = 'proto.MarketIndicators';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.QualityMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.QualityMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.QualityMetrics.displayName = 'proto.QualityMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DataSource = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DataSource, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DataSource.displayName = 'proto.DataSource';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PriceHistorySummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.PriceHistorySummary.repeatedFields_, null);
};
goog.inherits(proto.PriceHistorySummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PriceHistorySummary.displayName = 'proto.PriceHistorySummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DateRange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DateRange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DateRange.displayName = 'proto.DateRange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PriceStatistics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PriceStatistics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PriceStatistics.displayName = 'proto.PriceStatistics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SupplierSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SupplierSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SupplierSummary.displayName = 'proto.SupplierSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Meta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Meta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Meta.displayName = 'proto.Meta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GetFoundryItemsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.GetFoundryItemsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GetFoundryItemsRequest.displayName = 'proto.GetFoundryItemsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GetFoundryItemsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.GetFoundryItemsResponse.repeatedFields_, null);
};
goog.inherits(proto.GetFoundryItemsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GetFoundryItemsResponse.displayName = 'proto.GetFoundryItemsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GetFoundryItemsByCategoryPathRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.GetFoundryItemsByCategoryPathRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GetFoundryItemsByCategoryPathRequest.displayName = 'proto.GetFoundryItemsByCategoryPathRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GetFoundryItemsByCategoryPathResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.GetFoundryItemsByCategoryPathResponse.repeatedFields_, null);
};
goog.inherits(proto.GetFoundryItemsByCategoryPathResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GetFoundryItemsByCategoryPathResponse.displayName = 'proto.GetFoundryItemsByCategoryPathResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GetFoundryItemByIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.GetFoundryItemByIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GetFoundryItemByIdRequest.displayName = 'proto.GetFoundryItemByIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GetFoundryItemByIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.GetFoundryItemByIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GetFoundryItemByIdResponse.displayName = 'proto.GetFoundryItemByIdResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Category.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Category.prototype.toObject = function(opt_includeInstance) {
  return proto.Category.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Category} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Category.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
code: jspb.Message.getFieldWithDefault(msg, 3, ""),
path: jspb.Message.getFieldWithDefault(msg, 4, ""),
level: jspb.Message.getFieldWithDefault(msg, 5, 0),
itemCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
totalItemCount: jspb.Message.getFieldWithDefault(msg, 7, 0),
childrenList: jspb.Message.toObjectList(msg.getChildrenList(),
    proto.Category.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Category}
 */
proto.Category.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Category;
  return proto.Category.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Category} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Category}
 */
proto.Category.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLevel(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemCount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItemCount(value);
      break;
    case 8:
      var value = new proto.Category;
      reader.readMessage(value,proto.Category.deserializeBinaryFromReader);
      msg.addChildren(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Category.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Category.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Category} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Category.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getItemCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getTotalItemCount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getChildrenList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.Category.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.Category.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Category} returns this
 */
proto.Category.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.Category.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Category} returns this
 */
proto.Category.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string code = 3;
 * @return {string}
 */
proto.Category.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Category} returns this
 */
proto.Category.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string path = 4;
 * @return {string}
 */
proto.Category.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Category} returns this
 */
proto.Category.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 level = 5;
 * @return {number}
 */
proto.Category.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.Category} returns this
 */
proto.Category.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 item_count = 6;
 * @return {number}
 */
proto.Category.prototype.getItemCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.Category} returns this
 */
proto.Category.prototype.setItemCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 total_item_count = 7;
 * @return {number}
 */
proto.Category.prototype.getTotalItemCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.Category} returns this
 */
proto.Category.prototype.setTotalItemCount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated Category children = 8;
 * @return {!Array<!proto.Category>}
 */
proto.Category.prototype.getChildrenList = function() {
  return /** @type{!Array<!proto.Category>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Category, 8));
};


/**
 * @param {!Array<!proto.Category>} value
 * @return {!proto.Category} returns this
*/
proto.Category.prototype.setChildrenList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.Category=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Category}
 */
proto.Category.prototype.addChildren = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.Category, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Category} returns this
 */
proto.Category.prototype.clearChildrenList = function() {
  return this.setChildrenList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GetCategoriesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.GetCategoriesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetCategoriesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetCategoriesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sessiontoken: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetCategoriesRequest}
 */
proto.GetCategoriesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GetCategoriesRequest;
  return proto.GetCategoriesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetCategoriesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetCategoriesRequest}
 */
proto.GetCategoriesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessiontoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GetCategoriesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GetCategoriesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetCategoriesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetCategoriesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessiontoken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string sessionToken = 1;
 * @return {string}
 */
proto.GetCategoriesRequest.prototype.getSessiontoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.GetCategoriesRequest} returns this
 */
proto.GetCategoriesRequest.prototype.setSessiontoken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.GetCategoriesResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GetCategoriesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.GetCategoriesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetCategoriesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetCategoriesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
totalCategories: jspb.Message.getFieldWithDefault(msg, 1, 0),
maxDepth: jspb.Message.getFieldWithDefault(msg, 2, 0),
treeList: jspb.Message.toObjectList(msg.getTreeList(),
    proto.Category.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetCategoriesResponse}
 */
proto.GetCategoriesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GetCategoriesResponse;
  return proto.GetCategoriesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetCategoriesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetCategoriesResponse}
 */
proto.GetCategoriesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCategories(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxDepth(value);
      break;
    case 3:
      var value = new proto.Category;
      reader.readMessage(value,proto.Category.deserializeBinaryFromReader);
      msg.addTree(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GetCategoriesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GetCategoriesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetCategoriesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetCategoriesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalCategories();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMaxDepth();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTreeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.Category.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 total_categories = 1;
 * @return {number}
 */
proto.GetCategoriesResponse.prototype.getTotalCategories = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.GetCategoriesResponse} returns this
 */
proto.GetCategoriesResponse.prototype.setTotalCategories = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 max_depth = 2;
 * @return {number}
 */
proto.GetCategoriesResponse.prototype.getMaxDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.GetCategoriesResponse} returns this
 */
proto.GetCategoriesResponse.prototype.setMaxDepth = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated Category tree = 3;
 * @return {!Array<!proto.Category>}
 */
proto.GetCategoriesResponse.prototype.getTreeList = function() {
  return /** @type{!Array<!proto.Category>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Category, 3));
};


/**
 * @param {!Array<!proto.Category>} value
 * @return {!proto.GetCategoriesResponse} returns this
*/
proto.GetCategoriesResponse.prototype.setTreeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Category=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Category}
 */
proto.GetCategoriesResponse.prototype.addTree = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Category, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.GetCategoriesResponse} returns this
 */
proto.GetCategoriesResponse.prototype.clearTreeList = function() {
  return this.setTreeList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Dimensions.prototype.toObject = function(opt_includeInstance) {
  return proto.Dimensions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Dimensions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Dimensions.toObject = function(includeInstance, msg) {
  var f, obj = {
length: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
width: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
height: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
weight: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
volume: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
surfaceArea: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Dimensions}
 */
proto.Dimensions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Dimensions;
  return proto.Dimensions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Dimensions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Dimensions}
 */
proto.Dimensions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLength(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWidth(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeight(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setWeight(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setVolume(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSurfaceArea(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Dimensions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Dimensions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Dimensions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Dimensions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string length = 1;
 * @return {string}
 */
proto.Dimensions.prototype.getLength = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Dimensions} returns this
 */
proto.Dimensions.prototype.setLength = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Dimensions} returns this
 */
proto.Dimensions.prototype.clearLength = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Dimensions.prototype.hasLength = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string width = 2;
 * @return {string}
 */
proto.Dimensions.prototype.getWidth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Dimensions} returns this
 */
proto.Dimensions.prototype.setWidth = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Dimensions} returns this
 */
proto.Dimensions.prototype.clearWidth = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Dimensions.prototype.hasWidth = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string height = 3;
 * @return {string}
 */
proto.Dimensions.prototype.getHeight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Dimensions} returns this
 */
proto.Dimensions.prototype.setHeight = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Dimensions} returns this
 */
proto.Dimensions.prototype.clearHeight = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Dimensions.prototype.hasHeight = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string weight = 4;
 * @return {string}
 */
proto.Dimensions.prototype.getWeight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Dimensions} returns this
 */
proto.Dimensions.prototype.setWeight = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Dimensions} returns this
 */
proto.Dimensions.prototype.clearWeight = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Dimensions.prototype.hasWeight = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string volume = 5;
 * @return {string}
 */
proto.Dimensions.prototype.getVolume = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Dimensions} returns this
 */
proto.Dimensions.prototype.setVolume = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Dimensions} returns this
 */
proto.Dimensions.prototype.clearVolume = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Dimensions.prototype.hasVolume = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string surface_area = 6;
 * @return {string}
 */
proto.Dimensions.prototype.getSurfaceArea = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Dimensions} returns this
 */
proto.Dimensions.prototype.setSurfaceArea = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Dimensions} returns this
 */
proto.Dimensions.prototype.clearSurfaceArea = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Dimensions.prototype.hasSurfaceArea = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Unit.prototype.toObject = function(opt_includeInstance) {
  return proto.Unit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Unit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Unit.toObject = function(includeInstance, msg) {
  var f, obj = {
unitId: jspb.Message.getFieldWithDefault(msg, 1, ""),
unitCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
unitName: jspb.Message.getFieldWithDefault(msg, 3, ""),
unitType: jspb.Message.getFieldWithDefault(msg, 4, ""),
baseUnitCode: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
conversionFactor: jspb.Message.getFieldWithDefault(msg, 6, ""),
isImperial: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
isMetric: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Unit}
 */
proto.Unit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Unit;
  return proto.Unit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Unit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Unit}
 */
proto.Unit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnitId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnitCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnitName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnitType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBaseUnitCode(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setConversionFactor(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsImperial(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMetric(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Unit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Unit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Unit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Unit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnitId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUnitCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUnitName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUnitType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getConversionFactor();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIsImperial();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getIsMetric();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string unit_id = 1;
 * @return {string}
 */
proto.Unit.prototype.getUnitId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Unit} returns this
 */
proto.Unit.prototype.setUnitId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string unit_code = 2;
 * @return {string}
 */
proto.Unit.prototype.getUnitCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Unit} returns this
 */
proto.Unit.prototype.setUnitCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string unit_name = 3;
 * @return {string}
 */
proto.Unit.prototype.getUnitName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Unit} returns this
 */
proto.Unit.prototype.setUnitName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string unit_type = 4;
 * @return {string}
 */
proto.Unit.prototype.getUnitType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Unit} returns this
 */
proto.Unit.prototype.setUnitType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string base_unit_code = 5;
 * @return {string}
 */
proto.Unit.prototype.getBaseUnitCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Unit} returns this
 */
proto.Unit.prototype.setBaseUnitCode = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Unit} returns this
 */
proto.Unit.prototype.clearBaseUnitCode = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Unit.prototype.hasBaseUnitCode = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string conversion_factor = 6;
 * @return {string}
 */
proto.Unit.prototype.getConversionFactor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Unit} returns this
 */
proto.Unit.prototype.setConversionFactor = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool is_imperial = 7;
 * @return {boolean}
 */
proto.Unit.prototype.getIsImperial = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Unit} returns this
 */
proto.Unit.prototype.setIsImperial = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool is_metric = 8;
 * @return {boolean}
 */
proto.Unit.prototype.getIsMetric = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Unit} returns this
 */
proto.Unit.prototype.setIsMetric = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.FoundryItem.repeatedFields_ = [19];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.FoundryItem.prototype.toObject = function(opt_includeInstance) {
  return proto.FoundryItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.FoundryItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FoundryItem.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 2, ""),
updatedAt: jspb.Message.getFieldWithDefault(msg, 3, ""),
name: jspb.Message.getFieldWithDefault(msg, 4, ""),
description: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
status: jspb.Message.getFieldWithDefault(msg, 6, ""),
categoryId: jspb.Message.getFieldWithDefault(msg, 7, ""),
complexityScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
dimensions: (f = msg.getDimensions()) && proto.Dimensions.toObject(includeInstance, f),
imageUrl: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
lastValidatedAt: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
mlConfidenceScore: (f = jspb.Message.getOptionalFloatingPointField(msg, 12)) == null ? undefined : f,
parentId: (f = jspb.Message.getField(msg, 13)) == null ? undefined : f,
primaryUnit: (f = msg.getPrimaryUnit()) && proto.Unit.toObject(includeInstance, f),
secondaryUnit: (f = msg.getSecondaryUnit()) && proto.Unit.toObject(includeInstance, f),
qualityGrade: jspb.Message.getFieldWithDefault(msg, 16, ""),
unitConversionFactor: (f = jspb.Message.getField(msg, 17)) == null ? undefined : f,
validationScore: (f = jspb.Message.getOptionalFloatingPointField(msg, 18)) == null ? undefined : f,
priceHistoryList: jspb.Message.toObjectList(msg.getPriceHistoryList(),
    proto.PriceHistoryEntry.toObject, includeInstance),
priceSummary: (f = msg.getPriceSummary()) && proto.PriceHistorySummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FoundryItem}
 */
proto.FoundryItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.FoundryItem;
  return proto.FoundryItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FoundryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FoundryItem}
 */
proto.FoundryItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategoryId(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setComplexityScore(value);
      break;
    case 9:
      var value = new proto.Dimensions;
      reader.readMessage(value,proto.Dimensions.deserializeBinaryFromReader);
      msg.setDimensions(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastValidatedAt(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMlConfidenceScore(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentId(value);
      break;
    case 14:
      var value = new proto.Unit;
      reader.readMessage(value,proto.Unit.deserializeBinaryFromReader);
      msg.setPrimaryUnit(value);
      break;
    case 15:
      var value = new proto.Unit;
      reader.readMessage(value,proto.Unit.deserializeBinaryFromReader);
      msg.setSecondaryUnit(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setQualityGrade(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnitConversionFactor(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValidationScore(value);
      break;
    case 19:
      var value = new proto.PriceHistoryEntry;
      reader.readMessage(value,proto.PriceHistoryEntry.deserializeBinaryFromReader);
      msg.addPriceHistory(value);
      break;
    case 20:
      var value = new proto.PriceHistorySummary;
      reader.readMessage(value,proto.PriceHistorySummary.deserializeBinaryFromReader);
      msg.setPriceSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.FoundryItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.FoundryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FoundryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FoundryItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCategoryId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getComplexityScore();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getDimensions();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.Dimensions.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPrimaryUnit();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.Unit.serializeBinaryToWriter
    );
  }
  f = message.getSecondaryUnit();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.Unit.serializeBinaryToWriter
    );
  }
  f = message.getQualityGrade();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeString(
      17,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeDouble(
      18,
      f
    );
  }
  f = message.getPriceHistoryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      19,
      f,
      proto.PriceHistoryEntry.serializeBinaryToWriter
    );
  }
  f = message.getPriceSummary();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.PriceHistorySummary.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.FoundryItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string created_at = 2;
 * @return {string}
 */
proto.FoundryItem.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string updated_at = 3;
 * @return {string}
 */
proto.FoundryItem.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.FoundryItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.FoundryItem.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setDescription = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.clearDescription = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.FoundryItem.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.FoundryItem.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string category_id = 7;
 * @return {string}
 */
proto.FoundryItem.prototype.getCategoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setCategoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional double complexity_score = 8;
 * @return {number}
 */
proto.FoundryItem.prototype.getComplexityScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setComplexityScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional Dimensions dimensions = 9;
 * @return {?proto.Dimensions}
 */
proto.FoundryItem.prototype.getDimensions = function() {
  return /** @type{?proto.Dimensions} */ (
    jspb.Message.getWrapperField(this, proto.Dimensions, 9));
};


/**
 * @param {?proto.Dimensions|undefined} value
 * @return {!proto.FoundryItem} returns this
*/
proto.FoundryItem.prototype.setDimensions = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.clearDimensions = function() {
  return this.setDimensions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.FoundryItem.prototype.hasDimensions = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string image_url = 10;
 * @return {string}
 */
proto.FoundryItem.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setImageUrl = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.clearImageUrl = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.FoundryItem.prototype.hasImageUrl = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string last_validated_at = 11;
 * @return {string}
 */
proto.FoundryItem.prototype.getLastValidatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setLastValidatedAt = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.clearLastValidatedAt = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.FoundryItem.prototype.hasLastValidatedAt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional double ml_confidence_score = 12;
 * @return {number}
 */
proto.FoundryItem.prototype.getMlConfidenceScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setMlConfidenceScore = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.clearMlConfidenceScore = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.FoundryItem.prototype.hasMlConfidenceScore = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string parent_id = 13;
 * @return {string}
 */
proto.FoundryItem.prototype.getParentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setParentId = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.clearParentId = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.FoundryItem.prototype.hasParentId = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional Unit primary_unit = 14;
 * @return {?proto.Unit}
 */
proto.FoundryItem.prototype.getPrimaryUnit = function() {
  return /** @type{?proto.Unit} */ (
    jspb.Message.getWrapperField(this, proto.Unit, 14));
};


/**
 * @param {?proto.Unit|undefined} value
 * @return {!proto.FoundryItem} returns this
*/
proto.FoundryItem.prototype.setPrimaryUnit = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.clearPrimaryUnit = function() {
  return this.setPrimaryUnit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.FoundryItem.prototype.hasPrimaryUnit = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional Unit secondary_unit = 15;
 * @return {?proto.Unit}
 */
proto.FoundryItem.prototype.getSecondaryUnit = function() {
  return /** @type{?proto.Unit} */ (
    jspb.Message.getWrapperField(this, proto.Unit, 15));
};


/**
 * @param {?proto.Unit|undefined} value
 * @return {!proto.FoundryItem} returns this
*/
proto.FoundryItem.prototype.setSecondaryUnit = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.clearSecondaryUnit = function() {
  return this.setSecondaryUnit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.FoundryItem.prototype.hasSecondaryUnit = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string quality_grade = 16;
 * @return {string}
 */
proto.FoundryItem.prototype.getQualityGrade = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setQualityGrade = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string unit_conversion_factor = 17;
 * @return {string}
 */
proto.FoundryItem.prototype.getUnitConversionFactor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setUnitConversionFactor = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.clearUnitConversionFactor = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.FoundryItem.prototype.hasUnitConversionFactor = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional double validation_score = 18;
 * @return {number}
 */
proto.FoundryItem.prototype.getValidationScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.setValidationScore = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.clearValidationScore = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.FoundryItem.prototype.hasValidationScore = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * repeated PriceHistoryEntry price_history = 19;
 * @return {!Array<!proto.PriceHistoryEntry>}
 */
proto.FoundryItem.prototype.getPriceHistoryList = function() {
  return /** @type{!Array<!proto.PriceHistoryEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.PriceHistoryEntry, 19));
};


/**
 * @param {!Array<!proto.PriceHistoryEntry>} value
 * @return {!proto.FoundryItem} returns this
*/
proto.FoundryItem.prototype.setPriceHistoryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 19, value);
};


/**
 * @param {!proto.PriceHistoryEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.PriceHistoryEntry}
 */
proto.FoundryItem.prototype.addPriceHistory = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 19, opt_value, proto.PriceHistoryEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.clearPriceHistoryList = function() {
  return this.setPriceHistoryList([]);
};


/**
 * optional PriceHistorySummary price_summary = 20;
 * @return {?proto.PriceHistorySummary}
 */
proto.FoundryItem.prototype.getPriceSummary = function() {
  return /** @type{?proto.PriceHistorySummary} */ (
    jspb.Message.getWrapperField(this, proto.PriceHistorySummary, 20));
};


/**
 * @param {?proto.PriceHistorySummary|undefined} value
 * @return {!proto.FoundryItem} returns this
*/
proto.FoundryItem.prototype.setPriceSummary = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.FoundryItem} returns this
 */
proto.FoundryItem.prototype.clearPriceSummary = function() {
  return this.setPriceSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.FoundryItem.prototype.hasPriceSummary = function() {
  return jspb.Message.getField(this, 20) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PriceHistoryEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.PriceHistoryEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PriceHistoryEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PriceHistoryEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
priceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
price: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
currency: jspb.Message.getFieldWithDefault(msg, 3, ""),
priceType: jspb.Message.getFieldWithDefault(msg, 4, ""),
regionCode: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
countryCode: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
stateProvince: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
city: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
postalCode: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
supplier: (f = msg.getSupplier()) && proto.Supplier.toObject(includeInstance, f),
quantityRange: (f = msg.getQuantityRange()) && proto.QuantityRange.toObject(includeInstance, f),
unitOfMeasure: (f = msg.getUnitOfMeasure()) && proto.Unit.toObject(includeInstance, f),
marketIndicators: (f = msg.getMarketIndicators()) && proto.MarketIndicators.toObject(includeInstance, f),
qualityMetrics: (f = msg.getQualityMetrics()) && proto.QualityMetrics.toObject(includeInstance, f),
normalizedPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
source: (f = msg.getSource()) && proto.DataSource.toObject(includeInstance, f),
effectiveDate: jspb.Message.getFieldWithDefault(msg, 17, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PriceHistoryEntry}
 */
proto.PriceHistoryEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PriceHistoryEntry;
  return proto.PriceHistoryEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PriceHistoryEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PriceHistoryEntry}
 */
proto.PriceHistoryEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegionCode(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStateProvince(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostalCode(value);
      break;
    case 10:
      var value = new proto.Supplier;
      reader.readMessage(value,proto.Supplier.deserializeBinaryFromReader);
      msg.setSupplier(value);
      break;
    case 11:
      var value = new proto.QuantityRange;
      reader.readMessage(value,proto.QuantityRange.deserializeBinaryFromReader);
      msg.setQuantityRange(value);
      break;
    case 12:
      var value = new proto.Unit;
      reader.readMessage(value,proto.Unit.deserializeBinaryFromReader);
      msg.setUnitOfMeasure(value);
      break;
    case 13:
      var value = new proto.MarketIndicators;
      reader.readMessage(value,proto.MarketIndicators.deserializeBinaryFromReader);
      msg.setMarketIndicators(value);
      break;
    case 14:
      var value = new proto.QualityMetrics;
      reader.readMessage(value,proto.QualityMetrics.deserializeBinaryFromReader);
      msg.setQualityMetrics(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setNormalizedPrice(value);
      break;
    case 16:
      var value = new proto.DataSource;
      reader.readMessage(value,proto.DataSource.deserializeBinaryFromReader);
      msg.setSource(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setEffectiveDate(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PriceHistoryEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PriceHistoryEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PriceHistoryEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PriceHistoryEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPriceType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSupplier();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.Supplier.serializeBinaryToWriter
    );
  }
  f = message.getQuantityRange();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.QuantityRange.serializeBinaryToWriter
    );
  }
  f = message.getUnitOfMeasure();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.Unit.serializeBinaryToWriter
    );
  }
  f = message.getMarketIndicators();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.MarketIndicators.serializeBinaryToWriter
    );
  }
  f = message.getQualityMetrics();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.QualityMetrics.serializeBinaryToWriter
    );
  }
  f = message.getNormalizedPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getSource();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.DataSource.serializeBinaryToWriter
    );
  }
  f = message.getEffectiveDate();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional string price_id = 1;
 * @return {string}
 */
proto.PriceHistoryEntry.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double price = 2;
 * @return {number}
 */
proto.PriceHistoryEntry.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string currency = 3;
 * @return {string}
 */
proto.PriceHistoryEntry.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string price_type = 4;
 * @return {string}
 */
proto.PriceHistoryEntry.prototype.getPriceType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string region_code = 5;
 * @return {string}
 */
proto.PriceHistoryEntry.prototype.getRegionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.setRegionCode = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.clearRegionCode = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceHistoryEntry.prototype.hasRegionCode = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string country_code = 6;
 * @return {string}
 */
proto.PriceHistoryEntry.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.setCountryCode = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.clearCountryCode = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceHistoryEntry.prototype.hasCountryCode = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string state_province = 7;
 * @return {string}
 */
proto.PriceHistoryEntry.prototype.getStateProvince = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.setStateProvince = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.clearStateProvince = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceHistoryEntry.prototype.hasStateProvince = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string city = 8;
 * @return {string}
 */
proto.PriceHistoryEntry.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.setCity = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.clearCity = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceHistoryEntry.prototype.hasCity = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string postal_code = 9;
 * @return {string}
 */
proto.PriceHistoryEntry.prototype.getPostalCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.setPostalCode = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.clearPostalCode = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceHistoryEntry.prototype.hasPostalCode = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Supplier supplier = 10;
 * @return {?proto.Supplier}
 */
proto.PriceHistoryEntry.prototype.getSupplier = function() {
  return /** @type{?proto.Supplier} */ (
    jspb.Message.getWrapperField(this, proto.Supplier, 10));
};


/**
 * @param {?proto.Supplier|undefined} value
 * @return {!proto.PriceHistoryEntry} returns this
*/
proto.PriceHistoryEntry.prototype.setSupplier = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.clearSupplier = function() {
  return this.setSupplier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceHistoryEntry.prototype.hasSupplier = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional QuantityRange quantity_range = 11;
 * @return {?proto.QuantityRange}
 */
proto.PriceHistoryEntry.prototype.getQuantityRange = function() {
  return /** @type{?proto.QuantityRange} */ (
    jspb.Message.getWrapperField(this, proto.QuantityRange, 11));
};


/**
 * @param {?proto.QuantityRange|undefined} value
 * @return {!proto.PriceHistoryEntry} returns this
*/
proto.PriceHistoryEntry.prototype.setQuantityRange = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.clearQuantityRange = function() {
  return this.setQuantityRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceHistoryEntry.prototype.hasQuantityRange = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional Unit unit_of_measure = 12;
 * @return {?proto.Unit}
 */
proto.PriceHistoryEntry.prototype.getUnitOfMeasure = function() {
  return /** @type{?proto.Unit} */ (
    jspb.Message.getWrapperField(this, proto.Unit, 12));
};


/**
 * @param {?proto.Unit|undefined} value
 * @return {!proto.PriceHistoryEntry} returns this
*/
proto.PriceHistoryEntry.prototype.setUnitOfMeasure = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.clearUnitOfMeasure = function() {
  return this.setUnitOfMeasure(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceHistoryEntry.prototype.hasUnitOfMeasure = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional MarketIndicators market_indicators = 13;
 * @return {?proto.MarketIndicators}
 */
proto.PriceHistoryEntry.prototype.getMarketIndicators = function() {
  return /** @type{?proto.MarketIndicators} */ (
    jspb.Message.getWrapperField(this, proto.MarketIndicators, 13));
};


/**
 * @param {?proto.MarketIndicators|undefined} value
 * @return {!proto.PriceHistoryEntry} returns this
*/
proto.PriceHistoryEntry.prototype.setMarketIndicators = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.clearMarketIndicators = function() {
  return this.setMarketIndicators(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceHistoryEntry.prototype.hasMarketIndicators = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional QualityMetrics quality_metrics = 14;
 * @return {?proto.QualityMetrics}
 */
proto.PriceHistoryEntry.prototype.getQualityMetrics = function() {
  return /** @type{?proto.QualityMetrics} */ (
    jspb.Message.getWrapperField(this, proto.QualityMetrics, 14));
};


/**
 * @param {?proto.QualityMetrics|undefined} value
 * @return {!proto.PriceHistoryEntry} returns this
*/
proto.PriceHistoryEntry.prototype.setQualityMetrics = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.clearQualityMetrics = function() {
  return this.setQualityMetrics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceHistoryEntry.prototype.hasQualityMetrics = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional double normalized_price = 15;
 * @return {number}
 */
proto.PriceHistoryEntry.prototype.getNormalizedPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.setNormalizedPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional DataSource source = 16;
 * @return {?proto.DataSource}
 */
proto.PriceHistoryEntry.prototype.getSource = function() {
  return /** @type{?proto.DataSource} */ (
    jspb.Message.getWrapperField(this, proto.DataSource, 16));
};


/**
 * @param {?proto.DataSource|undefined} value
 * @return {!proto.PriceHistoryEntry} returns this
*/
proto.PriceHistoryEntry.prototype.setSource = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.clearSource = function() {
  return this.setSource(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceHistoryEntry.prototype.hasSource = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string effective_date = 17;
 * @return {string}
 */
proto.PriceHistoryEntry.prototype.getEffectiveDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.setEffectiveDate = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string created_at = 18;
 * @return {string}
 */
proto.PriceHistoryEntry.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceHistoryEntry} returns this
 */
proto.PriceHistoryEntry.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Supplier.prototype.toObject = function(opt_includeInstance) {
  return proto.Supplier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Supplier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Supplier.toObject = function(includeInstance, msg) {
  var f, obj = {
supplierId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
supplierType: jspb.Message.getFieldWithDefault(msg, 3, ""),
website: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Supplier}
 */
proto.Supplier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Supplier;
  return proto.Supplier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Supplier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Supplier}
 */
proto.Supplier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupplierId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupplierType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebsite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Supplier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Supplier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Supplier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Supplier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSupplierId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSupplierType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string supplier_id = 1;
 * @return {string}
 */
proto.Supplier.prototype.getSupplierId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Supplier} returns this
 */
proto.Supplier.prototype.setSupplierId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.Supplier.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Supplier} returns this
 */
proto.Supplier.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string supplier_type = 3;
 * @return {string}
 */
proto.Supplier.prototype.getSupplierType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Supplier} returns this
 */
proto.Supplier.prototype.setSupplierType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string website = 4;
 * @return {string}
 */
proto.Supplier.prototype.getWebsite = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Supplier} returns this
 */
proto.Supplier.prototype.setWebsite = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Supplier} returns this
 */
proto.Supplier.prototype.clearWebsite = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Supplier.prototype.hasWebsite = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.QuantityRange.prototype.toObject = function(opt_includeInstance) {
  return proto.QuantityRange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.QuantityRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.QuantityRange.toObject = function(includeInstance, msg) {
  var f, obj = {
min: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
max: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.QuantityRange}
 */
proto.QuantityRange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.QuantityRange;
  return proto.QuantityRange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.QuantityRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.QuantityRange}
 */
proto.QuantityRange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.QuantityRange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.QuantityRange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.QuantityRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.QuantityRange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 min = 1;
 * @return {number}
 */
proto.QuantityRange.prototype.getMin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.QuantityRange} returns this
 */
proto.QuantityRange.prototype.setMin = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.QuantityRange} returns this
 */
proto.QuantityRange.prototype.clearMin = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.QuantityRange.prototype.hasMin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 max = 2;
 * @return {number}
 */
proto.QuantityRange.prototype.getMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.QuantityRange} returns this
 */
proto.QuantityRange.prototype.setMax = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.QuantityRange} returns this
 */
proto.QuantityRange.prototype.clearMax = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.QuantityRange.prototype.hasMax = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MarketIndicators.prototype.toObject = function(opt_includeInstance) {
  return proto.MarketIndicators.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MarketIndicators} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MarketIndicators.toObject = function(includeInstance, msg) {
  var f, obj = {
demandIndex: (f = jspb.Message.getOptionalFloatingPointField(msg, 1)) == null ? undefined : f,
seasonalFactor: (f = jspb.Message.getOptionalFloatingPointField(msg, 2)) == null ? undefined : f,
availabilityScore: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MarketIndicators}
 */
proto.MarketIndicators.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MarketIndicators;
  return proto.MarketIndicators.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MarketIndicators} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MarketIndicators}
 */
proto.MarketIndicators.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDemandIndex(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSeasonalFactor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvailabilityScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MarketIndicators.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MarketIndicators.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MarketIndicators} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MarketIndicators.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional double demand_index = 1;
 * @return {number}
 */
proto.MarketIndicators.prototype.getDemandIndex = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.MarketIndicators} returns this
 */
proto.MarketIndicators.prototype.setDemandIndex = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.MarketIndicators} returns this
 */
proto.MarketIndicators.prototype.clearDemandIndex = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.MarketIndicators.prototype.hasDemandIndex = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double seasonal_factor = 2;
 * @return {number}
 */
proto.MarketIndicators.prototype.getSeasonalFactor = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.MarketIndicators} returns this
 */
proto.MarketIndicators.prototype.setSeasonalFactor = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.MarketIndicators} returns this
 */
proto.MarketIndicators.prototype.clearSeasonalFactor = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.MarketIndicators.prototype.hasSeasonalFactor = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double availability_score = 3;
 * @return {number}
 */
proto.MarketIndicators.prototype.getAvailabilityScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.MarketIndicators} returns this
 */
proto.MarketIndicators.prototype.setAvailabilityScore = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.MarketIndicators} returns this
 */
proto.MarketIndicators.prototype.clearAvailabilityScore = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.MarketIndicators.prototype.hasAvailabilityScore = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.QualityMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.QualityMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.QualityMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.QualityMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
confidenceScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
isVerified: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
isOutlier: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.QualityMetrics}
 */
proto.QualityMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.QualityMetrics;
  return proto.QualityMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.QualityMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.QualityMetrics}
 */
proto.QualityMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setConfidenceScore(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsVerified(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOutlier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.QualityMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.QualityMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.QualityMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.QualityMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfidenceScore();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getIsVerified();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIsOutlier();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional double confidence_score = 1;
 * @return {number}
 */
proto.QualityMetrics.prototype.getConfidenceScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.QualityMetrics} returns this
 */
proto.QualityMetrics.prototype.setConfidenceScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional bool is_verified = 2;
 * @return {boolean}
 */
proto.QualityMetrics.prototype.getIsVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.QualityMetrics} returns this
 */
proto.QualityMetrics.prototype.setIsVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool is_outlier = 3;
 * @return {boolean}
 */
proto.QualityMetrics.prototype.getIsOutlier = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.QualityMetrics} returns this
 */
proto.QualityMetrics.prototype.setIsOutlier = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DataSource.prototype.toObject = function(opt_includeInstance) {
  return proto.DataSource.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DataSource} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DataSource.toObject = function(includeInstance, msg) {
  var f, obj = {
dataSourceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
sourceName: jspb.Message.getFieldWithDefault(msg, 2, ""),
sourceUrl: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DataSource}
 */
proto.DataSource.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DataSource;
  return proto.DataSource.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DataSource} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DataSource}
 */
proto.DataSource.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataSourceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DataSource.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DataSource.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DataSource} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DataSource.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataSourceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSourceName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string data_source_id = 1;
 * @return {string}
 */
proto.DataSource.prototype.getDataSourceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.DataSource} returns this
 */
proto.DataSource.prototype.setDataSourceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string source_name = 2;
 * @return {string}
 */
proto.DataSource.prototype.getSourceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.DataSource} returns this
 */
proto.DataSource.prototype.setSourceName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string source_url = 3;
 * @return {string}
 */
proto.DataSource.prototype.getSourceUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.DataSource} returns this
 */
proto.DataSource.prototype.setSourceUrl = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.DataSource} returns this
 */
proto.DataSource.prototype.clearSourceUrl = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DataSource.prototype.hasSourceUrl = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.PriceHistorySummary.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PriceHistorySummary.prototype.toObject = function(opt_includeInstance) {
  return proto.PriceHistorySummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PriceHistorySummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PriceHistorySummary.toObject = function(includeInstance, msg) {
  var f, obj = {
totalRecords: jspb.Message.getFieldWithDefault(msg, 1, 0),
dateRange: (f = msg.getDateRange()) && proto.DateRange.toObject(includeInstance, f),
priceStatistics: (f = msg.getPriceStatistics()) && proto.PriceStatistics.toObject(includeInstance, f),
suppliersList: jspb.Message.toObjectList(msg.getSuppliersList(),
    proto.SupplierSummary.toObject, includeInstance),
priceTypesMap: (f = msg.getPriceTypesMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PriceHistorySummary}
 */
proto.PriceHistorySummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PriceHistorySummary;
  return proto.PriceHistorySummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PriceHistorySummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PriceHistorySummary}
 */
proto.PriceHistorySummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalRecords(value);
      break;
    case 2:
      var value = new proto.DateRange;
      reader.readMessage(value,proto.DateRange.deserializeBinaryFromReader);
      msg.setDateRange(value);
      break;
    case 3:
      var value = new proto.PriceStatistics;
      reader.readMessage(value,proto.PriceStatistics.deserializeBinaryFromReader);
      msg.setPriceStatistics(value);
      break;
    case 4:
      var value = new proto.SupplierSummary;
      reader.readMessage(value,proto.SupplierSummary.deserializeBinaryFromReader);
      msg.addSuppliers(value);
      break;
    case 5:
      var value = msg.getPriceTypesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readInt32, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PriceHistorySummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PriceHistorySummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PriceHistorySummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PriceHistorySummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalRecords();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDateRange();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.DateRange.serializeBinaryToWriter
    );
  }
  f = message.getPriceStatistics();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.PriceStatistics.serializeBinaryToWriter
    );
  }
  f = message.getSuppliersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.SupplierSummary.serializeBinaryToWriter
    );
  }
  f = message.getPriceTypesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeInt32);
  }
};


/**
 * optional int32 total_records = 1;
 * @return {number}
 */
proto.PriceHistorySummary.prototype.getTotalRecords = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.PriceHistorySummary} returns this
 */
proto.PriceHistorySummary.prototype.setTotalRecords = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional DateRange date_range = 2;
 * @return {?proto.DateRange}
 */
proto.PriceHistorySummary.prototype.getDateRange = function() {
  return /** @type{?proto.DateRange} */ (
    jspb.Message.getWrapperField(this, proto.DateRange, 2));
};


/**
 * @param {?proto.DateRange|undefined} value
 * @return {!proto.PriceHistorySummary} returns this
*/
proto.PriceHistorySummary.prototype.setDateRange = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PriceHistorySummary} returns this
 */
proto.PriceHistorySummary.prototype.clearDateRange = function() {
  return this.setDateRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceHistorySummary.prototype.hasDateRange = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PriceStatistics price_statistics = 3;
 * @return {?proto.PriceStatistics}
 */
proto.PriceHistorySummary.prototype.getPriceStatistics = function() {
  return /** @type{?proto.PriceStatistics} */ (
    jspb.Message.getWrapperField(this, proto.PriceStatistics, 3));
};


/**
 * @param {?proto.PriceStatistics|undefined} value
 * @return {!proto.PriceHistorySummary} returns this
*/
proto.PriceHistorySummary.prototype.setPriceStatistics = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PriceHistorySummary} returns this
 */
proto.PriceHistorySummary.prototype.clearPriceStatistics = function() {
  return this.setPriceStatistics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceHistorySummary.prototype.hasPriceStatistics = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated SupplierSummary suppliers = 4;
 * @return {!Array<!proto.SupplierSummary>}
 */
proto.PriceHistorySummary.prototype.getSuppliersList = function() {
  return /** @type{!Array<!proto.SupplierSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.SupplierSummary, 4));
};


/**
 * @param {!Array<!proto.SupplierSummary>} value
 * @return {!proto.PriceHistorySummary} returns this
*/
proto.PriceHistorySummary.prototype.setSuppliersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.SupplierSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.SupplierSummary}
 */
proto.PriceHistorySummary.prototype.addSuppliers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.SupplierSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.PriceHistorySummary} returns this
 */
proto.PriceHistorySummary.prototype.clearSuppliersList = function() {
  return this.setSuppliersList([]);
};


/**
 * map<string, int32> price_types = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.PriceHistorySummary.prototype.getPriceTypesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.PriceHistorySummary} returns this
 */
proto.PriceHistorySummary.prototype.clearPriceTypesMap = function() {
  this.getPriceTypesMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DateRange.prototype.toObject = function(opt_includeInstance) {
  return proto.DateRange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DateRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DateRange.toObject = function(includeInstance, msg) {
  var f, obj = {
start: jspb.Message.getFieldWithDefault(msg, 1, ""),
end: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DateRange}
 */
proto.DateRange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DateRange;
  return proto.DateRange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DateRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DateRange}
 */
proto.DateRange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DateRange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DateRange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DateRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DateRange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string start = 1;
 * @return {string}
 */
proto.DateRange.prototype.getStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.DateRange} returns this
 */
proto.DateRange.prototype.setStart = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string end = 2;
 * @return {string}
 */
proto.DateRange.prototype.getEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.DateRange} returns this
 */
proto.DateRange.prototype.setEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PriceStatistics.prototype.toObject = function(opt_includeInstance) {
  return proto.PriceStatistics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PriceStatistics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PriceStatistics.toObject = function(includeInstance, msg) {
  var f, obj = {
minPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
maxPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
avgPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
medianPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
priceTrend: jspb.Message.getFieldWithDefault(msg, 5, ""),
volatility: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PriceStatistics}
 */
proto.PriceStatistics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PriceStatistics;
  return proto.PriceStatistics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PriceStatistics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PriceStatistics}
 */
proto.PriceStatistics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinPrice(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxPrice(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgPrice(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMedianPrice(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceTrend(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVolatility(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PriceStatistics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PriceStatistics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PriceStatistics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PriceStatistics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMinPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getMaxPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getAvgPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getMedianPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getPriceTrend();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getVolatility();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional double min_price = 1;
 * @return {number}
 */
proto.PriceStatistics.prototype.getMinPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.PriceStatistics} returns this
 */
proto.PriceStatistics.prototype.setMinPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double max_price = 2;
 * @return {number}
 */
proto.PriceStatistics.prototype.getMaxPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.PriceStatistics} returns this
 */
proto.PriceStatistics.prototype.setMaxPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double avg_price = 3;
 * @return {number}
 */
proto.PriceStatistics.prototype.getAvgPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.PriceStatistics} returns this
 */
proto.PriceStatistics.prototype.setAvgPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double median_price = 4;
 * @return {number}
 */
proto.PriceStatistics.prototype.getMedianPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.PriceStatistics} returns this
 */
proto.PriceStatistics.prototype.setMedianPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional string price_trend = 5;
 * @return {string}
 */
proto.PriceStatistics.prototype.getPriceTrend = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceStatistics} returns this
 */
proto.PriceStatistics.prototype.setPriceTrend = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional double volatility = 6;
 * @return {number}
 */
proto.PriceStatistics.prototype.getVolatility = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.PriceStatistics} returns this
 */
proto.PriceStatistics.prototype.setVolatility = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SupplierSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.SupplierSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SupplierSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SupplierSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
supplierId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
recordCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
avgPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SupplierSummary}
 */
proto.SupplierSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SupplierSummary;
  return proto.SupplierSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SupplierSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SupplierSummary}
 */
proto.SupplierSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupplierId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRecordCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SupplierSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SupplierSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SupplierSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SupplierSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSupplierId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRecordCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAvgPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional string supplier_id = 1;
 * @return {string}
 */
proto.SupplierSummary.prototype.getSupplierId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SupplierSummary} returns this
 */
proto.SupplierSummary.prototype.setSupplierId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.SupplierSummary.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SupplierSummary} returns this
 */
proto.SupplierSummary.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 record_count = 3;
 * @return {number}
 */
proto.SupplierSummary.prototype.getRecordCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.SupplierSummary} returns this
 */
proto.SupplierSummary.prototype.setRecordCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double avg_price = 4;
 * @return {number}
 */
proto.SupplierSummary.prototype.getAvgPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.SupplierSummary} returns this
 */
proto.SupplierSummary.prototype.setAvgPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Meta.prototype.toObject = function(opt_includeInstance) {
  return proto.Meta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Meta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Meta.toObject = function(includeInstance, msg) {
  var f, obj = {
total: jspb.Message.getFieldWithDefault(msg, 1, 0),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
perPage: jspb.Message.getFieldWithDefault(msg, 3, 0),
pages: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Meta}
 */
proto.Meta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Meta;
  return proto.Meta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Meta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Meta}
 */
proto.Meta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Meta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Meta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Meta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Meta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPerPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPages();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 total = 1;
 * @return {number}
 */
proto.Meta.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.Meta} returns this
 */
proto.Meta.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.Meta.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Meta} returns this
 */
proto.Meta.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 per_page = 3;
 * @return {number}
 */
proto.Meta.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.Meta} returns this
 */
proto.Meta.prototype.setPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 pages = 4;
 * @return {number}
 */
proto.Meta.prototype.getPages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.Meta} returns this
 */
proto.Meta.prototype.setPages = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GetFoundryItemsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.GetFoundryItemsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetFoundryItemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetFoundryItemsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sessiontoken: jspb.Message.getFieldWithDefault(msg, 1, ""),
categoryId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
page: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
perPage: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
search: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetFoundryItemsRequest}
 */
proto.GetFoundryItemsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GetFoundryItemsRequest;
  return proto.GetFoundryItemsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetFoundryItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetFoundryItemsRequest}
 */
proto.GetFoundryItemsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessiontoken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategoryId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GetFoundryItemsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GetFoundryItemsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetFoundryItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetFoundryItemsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessiontoken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string sessionToken = 1;
 * @return {string}
 */
proto.GetFoundryItemsRequest.prototype.getSessiontoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.GetFoundryItemsRequest} returns this
 */
proto.GetFoundryItemsRequest.prototype.setSessiontoken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string category_id = 2;
 * @return {string}
 */
proto.GetFoundryItemsRequest.prototype.getCategoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.GetFoundryItemsRequest} returns this
 */
proto.GetFoundryItemsRequest.prototype.setCategoryId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.GetFoundryItemsRequest} returns this
 */
proto.GetFoundryItemsRequest.prototype.clearCategoryId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetFoundryItemsRequest.prototype.hasCategoryId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.GetFoundryItemsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.GetFoundryItemsRequest} returns this
 */
proto.GetFoundryItemsRequest.prototype.setPage = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.GetFoundryItemsRequest} returns this
 */
proto.GetFoundryItemsRequest.prototype.clearPage = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetFoundryItemsRequest.prototype.hasPage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 per_page = 4;
 * @return {number}
 */
proto.GetFoundryItemsRequest.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.GetFoundryItemsRequest} returns this
 */
proto.GetFoundryItemsRequest.prototype.setPerPage = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.GetFoundryItemsRequest} returns this
 */
proto.GetFoundryItemsRequest.prototype.clearPerPage = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetFoundryItemsRequest.prototype.hasPerPage = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string search = 5;
 * @return {string}
 */
proto.GetFoundryItemsRequest.prototype.getSearch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.GetFoundryItemsRequest} returns this
 */
proto.GetFoundryItemsRequest.prototype.setSearch = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.GetFoundryItemsRequest} returns this
 */
proto.GetFoundryItemsRequest.prototype.clearSearch = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetFoundryItemsRequest.prototype.hasSearch = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.GetFoundryItemsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GetFoundryItemsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.GetFoundryItemsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetFoundryItemsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetFoundryItemsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.FoundryItem.toObject, includeInstance),
meta: (f = msg.getMeta()) && proto.Meta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetFoundryItemsResponse}
 */
proto.GetFoundryItemsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GetFoundryItemsResponse;
  return proto.GetFoundryItemsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetFoundryItemsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetFoundryItemsResponse}
 */
proto.GetFoundryItemsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.FoundryItem;
      reader.readMessage(value,proto.FoundryItem.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 2:
      var value = new proto.Meta;
      reader.readMessage(value,proto.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GetFoundryItemsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GetFoundryItemsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetFoundryItemsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetFoundryItemsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.FoundryItem.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.Meta.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FoundryItem data = 1;
 * @return {!Array<!proto.FoundryItem>}
 */
proto.GetFoundryItemsResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.FoundryItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.FoundryItem, 1));
};


/**
 * @param {!Array<!proto.FoundryItem>} value
 * @return {!proto.GetFoundryItemsResponse} returns this
*/
proto.GetFoundryItemsResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.FoundryItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.FoundryItem}
 */
proto.GetFoundryItemsResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.FoundryItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.GetFoundryItemsResponse} returns this
 */
proto.GetFoundryItemsResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.Meta}
 */
proto.GetFoundryItemsResponse.prototype.getMeta = function() {
  return /** @type{?proto.Meta} */ (
    jspb.Message.getWrapperField(this, proto.Meta, 2));
};


/**
 * @param {?proto.Meta|undefined} value
 * @return {!proto.GetFoundryItemsResponse} returns this
*/
proto.GetFoundryItemsResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GetFoundryItemsResponse} returns this
 */
proto.GetFoundryItemsResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetFoundryItemsResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GetFoundryItemsByCategoryPathRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.GetFoundryItemsByCategoryPathRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetFoundryItemsByCategoryPathRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetFoundryItemsByCategoryPathRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sessiontoken: jspb.Message.getFieldWithDefault(msg, 1, ""),
categorypath: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetFoundryItemsByCategoryPathRequest}
 */
proto.GetFoundryItemsByCategoryPathRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GetFoundryItemsByCategoryPathRequest;
  return proto.GetFoundryItemsByCategoryPathRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetFoundryItemsByCategoryPathRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetFoundryItemsByCategoryPathRequest}
 */
proto.GetFoundryItemsByCategoryPathRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessiontoken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategorypath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GetFoundryItemsByCategoryPathRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GetFoundryItemsByCategoryPathRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetFoundryItemsByCategoryPathRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetFoundryItemsByCategoryPathRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessiontoken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCategorypath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string sessionToken = 1;
 * @return {string}
 */
proto.GetFoundryItemsByCategoryPathRequest.prototype.getSessiontoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.GetFoundryItemsByCategoryPathRequest} returns this
 */
proto.GetFoundryItemsByCategoryPathRequest.prototype.setSessiontoken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string categoryPath = 2;
 * @return {string}
 */
proto.GetFoundryItemsByCategoryPathRequest.prototype.getCategorypath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.GetFoundryItemsByCategoryPathRequest} returns this
 */
proto.GetFoundryItemsByCategoryPathRequest.prototype.setCategorypath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.GetFoundryItemsByCategoryPathResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GetFoundryItemsByCategoryPathResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.GetFoundryItemsByCategoryPathResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetFoundryItemsByCategoryPathResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetFoundryItemsByCategoryPathResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.FoundryItem.toObject, includeInstance),
meta: (f = msg.getMeta()) && proto.Meta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetFoundryItemsByCategoryPathResponse}
 */
proto.GetFoundryItemsByCategoryPathResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GetFoundryItemsByCategoryPathResponse;
  return proto.GetFoundryItemsByCategoryPathResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetFoundryItemsByCategoryPathResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetFoundryItemsByCategoryPathResponse}
 */
proto.GetFoundryItemsByCategoryPathResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.FoundryItem;
      reader.readMessage(value,proto.FoundryItem.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 2:
      var value = new proto.Meta;
      reader.readMessage(value,proto.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GetFoundryItemsByCategoryPathResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GetFoundryItemsByCategoryPathResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetFoundryItemsByCategoryPathResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetFoundryItemsByCategoryPathResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.FoundryItem.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.Meta.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FoundryItem data = 1;
 * @return {!Array<!proto.FoundryItem>}
 */
proto.GetFoundryItemsByCategoryPathResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.FoundryItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.FoundryItem, 1));
};


/**
 * @param {!Array<!proto.FoundryItem>} value
 * @return {!proto.GetFoundryItemsByCategoryPathResponse} returns this
*/
proto.GetFoundryItemsByCategoryPathResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.FoundryItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.FoundryItem}
 */
proto.GetFoundryItemsByCategoryPathResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.FoundryItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.GetFoundryItemsByCategoryPathResponse} returns this
 */
proto.GetFoundryItemsByCategoryPathResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.Meta}
 */
proto.GetFoundryItemsByCategoryPathResponse.prototype.getMeta = function() {
  return /** @type{?proto.Meta} */ (
    jspb.Message.getWrapperField(this, proto.Meta, 2));
};


/**
 * @param {?proto.Meta|undefined} value
 * @return {!proto.GetFoundryItemsByCategoryPathResponse} returns this
*/
proto.GetFoundryItemsByCategoryPathResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GetFoundryItemsByCategoryPathResponse} returns this
 */
proto.GetFoundryItemsByCategoryPathResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetFoundryItemsByCategoryPathResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GetFoundryItemByIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.GetFoundryItemByIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetFoundryItemByIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetFoundryItemByIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sessiontoken: jspb.Message.getFieldWithDefault(msg, 1, ""),
id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetFoundryItemByIdRequest}
 */
proto.GetFoundryItemByIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GetFoundryItemByIdRequest;
  return proto.GetFoundryItemByIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetFoundryItemByIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetFoundryItemByIdRequest}
 */
proto.GetFoundryItemByIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessiontoken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GetFoundryItemByIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GetFoundryItemByIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetFoundryItemByIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetFoundryItemByIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessiontoken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string sessionToken = 1;
 * @return {string}
 */
proto.GetFoundryItemByIdRequest.prototype.getSessiontoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.GetFoundryItemByIdRequest} returns this
 */
proto.GetFoundryItemByIdRequest.prototype.setSessiontoken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.GetFoundryItemByIdRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.GetFoundryItemByIdRequest} returns this
 */
proto.GetFoundryItemByIdRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GetFoundryItemByIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.GetFoundryItemByIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetFoundryItemByIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetFoundryItemByIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.FoundryItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetFoundryItemByIdResponse}
 */
proto.GetFoundryItemByIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GetFoundryItemByIdResponse;
  return proto.GetFoundryItemByIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetFoundryItemByIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetFoundryItemByIdResponse}
 */
proto.GetFoundryItemByIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.FoundryItem;
      reader.readMessage(value,proto.FoundryItem.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GetFoundryItemByIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GetFoundryItemByIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetFoundryItemByIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetFoundryItemByIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.FoundryItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional FoundryItem data = 1;
 * @return {?proto.FoundryItem}
 */
proto.GetFoundryItemByIdResponse.prototype.getData = function() {
  return /** @type{?proto.FoundryItem} */ (
    jspb.Message.getWrapperField(this, proto.FoundryItem, 1));
};


/**
 * @param {?proto.FoundryItem|undefined} value
 * @return {!proto.GetFoundryItemByIdResponse} returns this
*/
proto.GetFoundryItemByIdResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GetFoundryItemByIdResponse} returns this
 */
proto.GetFoundryItemByIdResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GetFoundryItemByIdResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto);
